import React from "react"

export function Privacy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_324_5170)">
        <path
          d="M6.125 7C7.05326 7 7.9435 6.63125 8.59987 5.97487C9.25625 5.3185 9.625 4.42826 9.625 3.5C9.625 2.57174 9.25625 1.6815 8.59987 1.02513C7.9435 0.368749 7.05326 0 6.125 0C5.19674 0 4.3065 0.368749 3.65013 1.02513C2.99375 1.6815 2.625 2.57174 2.625 3.5C2.625 4.42826 2.99375 5.3185 3.65013 5.97487C4.3065 6.63125 5.19674 7 6.125 7ZM4.87539 8.3125C2.18203 8.3125 0 10.4945 0 13.1879C0 13.6363 0.363672 14 0.812109 14H11.4379C11.4871 14 11.5336 13.9945 11.5828 13.9863C9.49648 12.4797 8.85391 10.1309 8.76367 8.51211C8.32344 8.38086 7.85859 8.3125 7.37734 8.3125H4.87539ZM13.3191 6.17148L10.0379 7.48398C9.78906 7.58516 9.625 7.82578 9.625 8.09375C9.625 9.82461 10.3332 12.7094 13.3109 13.9508C13.4723 14.0191 13.6555 14.0191 13.8168 13.9508C16.7918 12.7094 17.5 9.82461 17.5 8.09375C17.5 7.82578 17.3359 7.58516 17.0871 7.48398L13.8059 6.17148C13.65 6.10859 13.475 6.10859 13.3191 6.17148ZM16.1711 8.53125C16.0645 9.91758 15.4273 11.7223 13.5625 12.6246V7.48672L16.1711 8.53125Z"
          fill="#9333EA"
        />
      </g>
      <defs>
        <clipPath id="clip0_324_5170">
          <path d="M0 0H17.5V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
